import { api } from "@/services/api";
import { useEffect } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";

export default function EmailConfirmation() {
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");

  useEffect(() => {
    const confirmEmail = async () => {
        try{
           await api.get("/user/confirmation", { params: {
                token
            }})
            toast.success("Email Confirmado Com Sucesso!");
        }catch(e) {
            toast.error("Ocorreu um erro ao tentar confirmar seu email")
        }
        
    }
    confirmEmail()

  }, []);

  return <Navigate to="/dashboard" />;
}
